export default {
    createMode: {
        ufNameInput: '/globaladmin/8x8-catalog/create/input/name',
        ufParentSelect: '/globaladmin/8x8-catalog/create/select/parent',
        ufDescriptionInput: '/globaladmin/8x8-catalog/create/input/description',
        ufSkuInput: '/globaladmin/8x8-catalog/create/input/sku',
        ufOfferingIdInput: '/globaladmin/8x8-catalog/create/input/offeringId',
        ufVisibilitySelect: '/globaladmin/8x8-catalog/create/select/visibility',
        ufRuleSelect: '/globaladmin/8x8-catalog/create/select/rule',
        ufBackBtn: '/globaladmin/8x8-catalog/create/button/back',
        ufCreateBtn: '/globaladmin/8x8-catalog/create/button/create',
        ufEditBtn: '/globaladmin/8x8-catalog/edit/button/save',
    },
    ufAddCatalogItemBtn: '/globaladmin/8x8-catalog/table/button/add',
};
